module.exports = __webpack_public_path__ + "static/media/30.23b7b015.jpg";